import { useTranslation } from 'react-i18next'

import { OPERATION_EXPORT_CONTACTS } from '../operations-gql/queries'
import { useSites } from 'store'
import useFilters from '../store'
import Export from 'components/global/Modals/Export'
import { trackEvent } from 'analytics'

const ContactsExport = () => {
  const [{ selected }] = useSites()
  const [filters] = useFilters()
  const { i18n } = useTranslation()
  return (
    <Export
      title="contacts.export.title"
      formats={[
        { type: 'xlsx', icon: 'fa-file', label: 'contacts.export.xlsx' },
        { type: 'csv', icon: 'fa-file-csv', label: 'contacts.export.csv' }
      ]}
      query={OPERATION_EXPORT_CONTACTS}
      variables={{
        site_ids: selected.map(({sf_id}) => sf_id),
        ...filters,
        language: i18n.language
      }}
      exportFieldName="exportContacts"
      onExport={format => trackEvent('users_exported', { format })}
    />
  )
}

export default ContactsExport
